import React from 'react';
import Popup from 'reactjs-popup';
import { Button, Form } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from '../utils/siteUtils.js';
import { Loading } from '../components/Loading';
import '../styles/Attestation.css';
export default class AttestationDisplay extends React.Component {
    constructor(props) {
        super(props)
        this.generateDisplay = this.generateDisplay.bind(this);
        this.onCheckBoxClick1 = this.onCheckBoxClick1.bind(this)
        this.onCheckBoxClick2 = this.onCheckBoxClick2.bind(this)
        this.onCancel = this.onCancel.bind(this);
        this.onAttest = this.onAttest.bind(this);
        this.state = {
            showModal: false,
            attestClicked: false,
            showLoading:false
        };
    }

    componentDidMount() {
        this.setState({
            showModal:this.props.showAttest
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showAttest !== this.props.showAttest) {
            this.setState({
                showModal: this.props.showAttest
            });
        }
    }

    onCheckBoxClick1() {
        this.setState({
            checkBoxClicked1: !this.state.checkBoxClicked1
        });
    } 
    onCheckBoxClick2() {
        this.setState({
            checkBoxClicked2: !this.state.checkBoxClicked2
        });
    }
    onCancel() {        
        this.setState({
            showModal: !this.props.showAttest,
            attestClicked: false,
        });

        this.props.onLogout();
    }

    onAttest() {
        this.setState({ showLoading: true });
        ServiceCalls.onUserAttestation().then(function (data) {
            var statusMsg = (data && data.status) ? data.status : false;
            console.log(`Call to create user attestation returned ${statusMsg}`);
            if (statusMsg === true) {
                this.setState({
                    showModal: false,
                    checkBoxClicked1: false,
                    checkBoxClicked2: false,
                    showLoading: false
                });
                this.props.onAttest();
            }
            else {
                var err = (data && data.error) ? data.error : "NO RESULT";
                console.log(`Attestation returned ${statusMsg}  Error: ${err}`);
            }
        }.bind(this));
    }

    generateDisplay() {
        const { showModal, checkBoxClicked1, checkBoxClicked2 } = this.state; 
                  
    
           
        return (
            <>
                <div id="attestationArea">
                    <h3 id="attestationTitle">Updated Terms of Service</h3>

                    <p className="reminderText">Please review and accept the following terms of service to sign in to your account.</p>

                    <div id="attestationOptionArea">

                        <div className="attestOpt" style={{ visibility: (showModal === true) ? 'visible' : 'hidden' }}>
                            <div className="attestCB">
                                <Form.Check                         
                                    type="checkbox"
                                    checked={ checkBoxClicked1}
                                    onChange={this.onCheckBoxClick1}
                                    id="attest-cb-attest" />
                            </div>
                            <div className="attestLink">
                                By selecting this checkbox, I have reviewed and agree to the <a href={CommonUtils.generateTOSUrl()} target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href={CommonUtils.generatePrivacyPolicyUrl()} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                            </div>
                        
                        </div>
                        <div className="attestOpt" style={{ visibility: (showModal === true) ? 'visible' : 'hidden' }}>
                            <div className="attestCB">
                                <Form.Check
                                    type="checkbox"
                                    checked={checkBoxClicked2}
                                    onChange={this.onCheckBoxClick2}
                                    id="attest-cb-another" />
                            </div>
                            <div className="attestLink">By selecting this checkbox, you acknowledge that you consent to our processing, use and storage of your personal information and that some third parties such as our affiliates and partners, and company personnel may not only have access to such data but may also be located in countries that do not provide the same level of data protection as your home country. We take appropriate steps to ensure that such entities are bound to duties of confidentiality, and we implement measures such as standard data protection contractual clauses to ensure that any transferred personal data remains protected and secure. Your continued use of this portal is confirmation that you consent to the processing of your personal data and acknowledge that the same level of safeguarding support may not always be available outside of your country. You can withdraw this consent at any time by contacting information_governance@optum.com.</div>
                        </div>
                    </div>
                    <div id="attestBtnArea">
                        {
                            (this.state.showLoading) ? <Loading /> :
                                <>
                                    <Button id="cancelAttestBtn" className="attestBtn" variant="primary" onClick={() => { this.onCancel() }}> Exit </Button>
                                    <Button id="attestBtn" className="attestBtn" style={{ visibility: (showModal === true && checkBoxClicked1 === true && checkBoxClicked2 === true ) ? 'visible' : 'hidden' }} variant="primary" onClick={() => { this.onAttest() }}> Attest </Button>
                                </>
                        }
                    </div>
                </div>
            </>
            );
    }

    render() {      
        const { showModal, /*ppClicked*/ } = this.state;        
        return (
            (this.state.isLoading)?<></>:
                <Popup open={showModal} modal closeOnDocumentClick={false} closeOnEscape={false}>
                 { this.generateDisplay() }                                     
            </Popup>            
            );  
        }
    }